module.exports = __webpack_public_path__ + "img/20200715_220738.11c2e673.jpg";